import { create } from 'zustand'

const initialQuizData = {
  questionId: '',
  answer: 0,
  isCorrect: null,
}

export const useDirectLearningStore = create((set, get) => ({
  originalData: null,
  quizData: initialQuizData,
  changedFields: new Set(),

  initializeFromData: (data) => {
    set({
      originalData: data ? { ...data } : null,
      quizData: { ...initialQuizData },
      changedFields: new Set(),
    })
  },

  insertDirectQuizData: (field, value) => {
    set((state) => {
      const newChangedFields = new Set(state.changedFields)
      newChangedFields.add(field)

      return {
        quizData: { ...state.quizData, [field]: value },
        changedFields: newChangedFields,
      }
    })
  },

  resetQuizData: () => {
    set({
      quizData: { ...initialQuizData },
      changedFields: new Set(),
    })
  },

  resetToOriginal: () => {
    const { originalData } = get()
    if (originalData) {
      get().initializeFromData(originalData)
    } else {
      set({
        originalData: null,
        quizData: { ...initialQuizData },
        changedFields: new Set(),
      })
    }
  },

  getChangedData: () => {
    const { quizData, changedFields } = get()

    if (changedFields.size === 0) {
      return null
    }

    const changedData = {}

    if (changedFields.has('userId')) {
      changedData.USER_ID = quizData.userId
    }
    if (changedFields.has('questionId')) {
      changedData.QUESTION_ID = quizData.questionId
    }
    if (changedFields.has('answer')) {
      changedData.ANSWER = quizData.answer
    }
    if (changedFields.has('isCorrect')) {
      changedData.IS_CORRECT = quizData.isCorrect ? 'Y' : 'N'
    }

    return Object.keys(changedData).length > 0 ? changedData : null
  },
}))

export default useDirectLearningStore
